import {IntegrationsByType} from 'common/models/success/integration';

import {RootState} from '../..';

const selectIntegrations: (state: RootState) => IntegrationsByType = (state) =>
    state.success.integrations || {};

export default selectIntegrations;
